/**************
 Cart
 ***************/
// open cart
async function openCart() {
    // open
    window.upcartOpenCart();
}


/**************
 UpCart free glass bottle functionality

 When a subscription is added (any subscription, no exceptions), we add a glass bottle for free.

 Rules:
 1. If there are no subscriptions in the cart, remove the glass bottle
 2. Only ever allow one glass bottle in the cart

 ***************/

// check if upcart is ready
function onUpcartReady(callback) {
    const check = () => {
        if (typeof window.upcartOpenCart === "function") {
            callback();
        } else {
            setTimeout(check, 100);
        }
    };
    check();
}

function registerUpcartEvents() {
    window.upcartOnCartLoaded = handleCartChange;
    window.upcartOnCartUpdated = handleCartChange;
    window.upcartOnItemRemoved = handleCartChange;
}

onUpcartReady(() => {
    const originalOpenCart = window.upcartOpenCart;

    window.upcartOpenCart = function () {
        registerUpcartEvents();

        return originalOpenCart.apply(this, arguments);
    }
    registerUpcartEvents();
});


// items added by a bundle PDP are paid components, not unearned gifts, so the sweepers below skip them
function isBundleItem(item) {
    return !!(item.properties && item.properties._bundle);
}


async function handleCartChange(cart) {

    // check if we need to retry (cart won't have cart.items)
    if (!cart.items) {
        registerUpcartEvents()
        return;
    }

    // update item count
    document.querySelector("#headerIconsCartCount").textContent = cart.item_count;


    // only need to run if we're auto adding the product to begin with (theme setting)
    if (!autoAddProduct) {
        return;
    }

    if (!autoAddProduct.variants[0].available) {
        return;
    }

    // check if cart contains a subscriptions
    const hasSubscription = cart.items.some(item => item.selling_plan_allocation);

    // check if auto add product is in the cart
    const hasAutoAddProduct = cart.items.some(item => item.product_id === autoAddProduct.id && !isBundleItem(item));

    // check if the pillow is in the cart but not the gummies (the pillow is the free gift for gummies)
    const hasAutoAddProductPillow = cart.items.some(item => item.product_id === 9447831372021 && !isBundleItem(item));
    const hasGummies = cart.items.some(item => item.product_id === 9361482514677);
    if (!hasGummies && hasAutoAddProductPillow) {
        // remove the pillow
        let updatePayload = {};
        cart.items.forEach(item => {
            if (item.product_id === 9447831372021 && !isBundleItem(item)) {
                updatePayload[item.key] = 0;
            }
        })

        await updateCart({updates: updatePayload});

        window.upcartRegisterAddToCart()
        window.upcartRefreshCart()
    }

    // check if the dwellspring is in the cart but not the gummies (dwellspring requires gummies)
    const hasDwellspring = cart.items.some(item => item.product_id === 9695204671733);
    if (!hasGummies && hasDwellspring) {
        // remove the dwellspring
        let updatePayload = {};
        cart.items.forEach(item => {
            if (item.product_id === 9695204671733) {
                updatePayload[item.key] = 0;
            }
        })

        await updateCart({updates: updatePayload});

        window.upcartRegisterAddToCart()
        window.upcartRefreshCart()
    }

    // if there is more than 1 dwellspring in the cart, remove all but one
    if (hasDwellspring) {
        const dwellspringQty = cart.items.filter(item => item.product_id === 9695204671733)[0].quantity;

        if (dwellspringQty > 1) {
            let updatePayload = {};
            cart.items.forEach(item => {
                if (item.product_id === 9695204671733 && item.quantity > 1) {
                    updatePayload[item.key] = 1;
                }
            });

            await updateCart({updates: updatePayload});

            window.upcartRegisterAddToCart()
            window.upcartRefreshCart()
        }
    }

    if (!hasAutoAddProduct) {
        return;
    }

    // if there are no subscriptions and the auto add product is in the cart, remove it
    if (!hasSubscription && hasAutoAddProduct) {
        let updatePayload = {};
        cart.items.forEach(item => {
            if (item.product_id === autoAddProduct.id && !isBundleItem(item)) {
                updatePayload[item.key] = 0;
            }
        })

        await updateCart({updates: updatePayload});

        window.upcartRegisterAddToCart()
        window.upcartRefreshCart()
    }

    // if there is more than 1 auto add product in the cart, remove all but one
    const autoAddProductQty = cart.items.filter(item => item.product_id === autoAddProduct.id && !isBundleItem(item))[0].quantity;

    if (autoAddProductQty > 1) {
        let updatePayload = {};
        cart.items.forEach(item => {
            if (item.product_id === autoAddProduct.id && item.quantity > 1 && !isBundleItem(item)) {
                updatePayload[item.key] = 1;
            }
        });

        await updateCart({updates: updatePayload});

        window.upcartRegisterAddToCart()
        window.upcartRefreshCart()
    }
}


// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}